import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import { ReactComponent as RadioOff } from "./../../../../assets/images/radio-off.svg";
import { ReactComponent as RadioOn } from "./../../../../assets/images/radio-on.svg";
import { ReactComponent as DDxEdit } from "./../../../../assets/images/ddx-edit.svg";

interface GenderInputProps {
  gender: string | null;
  setGender: React.Dispatch<React.SetStateAction<string | null>>;
  disabled?: boolean;
  onPressEdit: () => void;
  handleSubmit: (gender: string) => void;
  data?: Array<{ label: string; value: string }>;
  title?: string;
}

const GenderInput: React.FC<GenderInputProps | any> = ({
  gender,
  setGender,
  disabled = false,
  onPressEdit,
  handleSubmit,
  data,
  title,
}) => {
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const handleGenderSelect = (selected: string) => {
    setTimeout(() => {
      setGender(selected);
      handleSubmit(selected);
      setIsEditMode(false);
    }, 400);
  };

  const renderState = () => {
    if (gender && !isEditMode) {
      return (
        <motion.div
          key={`answered-${gender}`}
          initial={{
            opacity: 0,
            scale: 0.5,
            transformOrigin: "top right",
          }}
          animate={{ opacity: 1, scale: 1, transformOrigin: "top right" }}
          exit={{ opacity: 0, scale: 0.5, transformOrigin: "top right" }}
          transition={{ duration: 0.2 }}
          className="flex flex-row items-end gap-2.5 my-7 justify-end"
        >
          <button
            onClick={() => {
              onPressEdit();
              setIsEditMode(true);
              // setValue(null);
              setGender(null);
            }}
            className="mb-3"
          >
            <DDxEdit className="min-h-6 min-w-6" />
          </button>
          <div className="bg-white rounded-l-[18px] rounded-tr-[18px] shadow-[0px_0px_12px_0px_#A238FF0D] p-3.5 flex flex-col gap-4">
            <p className="text-sm leading-5 text-gray-800 font-normal">
              <span className="font-semibold">{title}: </span>
              {gender}
            </p>
          </div>
        </motion.div>
      );
    }
    return (
      <motion.div
        key={"unanswered"}
        initial={{
          opacity: 0,
          scale: 0.5,
          transformOrigin: "top right",
        }}
        animate={{ opacity: 1, scale: 1, transformOrigin: "top right" }}
        exit={{ opacity: 0, scale: 0.5, transformOrigin: "top right" }}
        transition={{ duration: 0.2 }}
        className="bg-white rounded-l-[18px] rounded-tr-[18px] ml-7 my-7 shadow-[0px_0px_12px_0px_#A238FF0D] p-3.5 flex flex-col gap-4"
      >
        <p className="font-semibold text-gray-800 text-left text-base leading-6">
          {title}
        </p>
        <div className="w-full grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2">
          {data.map((item: { label: string; value: string }, index: number) => (
            <button
              key={index}
              onClick={() => handleGenderSelect(item.value)}
              className={`flex flex-row items-center justify-between p-3 border-[1px] rounded-2xl ${
                gender === item.value
                  ? `border-primary bg-[#4B4AD51A]`
                  : `border-[#DCE4E8] bg-white`
              }`}
            >
              <p className="text-xs leading-4 font-semibold text-[#5A6774] truncate">
                {item.label}
              </p>
              {gender === item.value ? (
                <RadioOn className="flex-shrink-0" />
              ) : (
                <RadioOff className="flex-shrink-0" />
              )}
            </button>
          ))}
        </div>
      </motion.div>
    );
  };

  return (
    <div className={`${disabled && "opacity-50 pointer-events-none"}`}>
      <AnimatePresence mode="wait">{renderState()}</AnimatePresence>
    </div>
  );
};

export default GenderInput;
